/**
 * =============================================================================
 * Componente: AffiliateEmptyState
 * Versão: 1.0.0
 *
 * Descrição:
 *   Estado vazio padronizado para o painel premium do afiliado.
 *   Usa ícone em cápsula com gradiente, título forte e CTA opcional.
 * =============================================================================
 */
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface AffiliateEmptyStateProps {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function AffiliateEmptyState({
  icon,
  title,
  description,
  action,
  className,
}: AffiliateEmptyStateProps) {
  return (
    <div
      className={cn(
        'aff-card flex flex-col items-center gap-4 px-6 py-14 text-center',
        className,
      )}
    >
      <div
        className="flex h-16 w-16 items-center justify-center rounded-2xl text-[hsl(var(--aff-primary-foreground))]"
        style={{ background: 'var(--aff-gradient-hero)' }}
      >
        {icon}
      </div>
      <div className="space-y-1.5 max-w-md">
        <h2 className="text-lg font-bold text-[hsl(var(--aff-foreground))]">
          {title}
        </h2>
        {description && (
          <p className="text-sm text-[hsl(var(--aff-muted-foreground))]">
            {description}
          </p>
        )}
      </div>
      {action && <div className="pt-1">{action}</div>}
    </div>
  );
}
